const getList = Symbol('getList');

class EventProxy {
  constructor() {
    this.listeners = {};
  }

  [getList](action) {
    if (!this.listeners[action]) {
      this.listeners[action] = [];
    }
    return this.listeners[action];
  }

  on(action, callback) {
    this[getList](action).push(callback);
  }

  once(action, callback) {
    if (!callback) return;
    callback._once = true;
    this.on(action, callback);
  }

  off(action, callback) {
    const list = this[getList](action);
    for (let i = list.length - 1; i >= 0; i -= 1) {
      if (callback === list[i]) {
        list.splice(i, 1);
      }
    }
  }

  emit(action, data) {
    const list = this[getList](action).map(cb => cb);
    for (let i = 0; i < list.length; i += 1) {
      const callback = list[i];
      callback(data);
      if (list[i]._once) {
        this.off(action, callback);
      }
    }
  }
}

const eventProxy = new EventProxy();

export default eventProxy;
